import { FC } from 'react';

import { TablePagination } from 'modules/_shared/Table/components/TablePagination';

import documentTypes from 'constants/documentTypes';
import { useMyFolders } from '../context/MyFolders';
import FolderCard from './FolderCard';
import DocumentsList from '../../DocumentsListView';
import { DocumentsListProvider } from '../../DocumentsListView/context/DocumentsListPageContext';
import NoFolders from '../../NoFolders';
import SortButton from './SortButton';

const InsideFolderView: FC = () => {
  const { data, actions } = useMyFolders();

  const showPagination = data.foldersCount > 5;

  const hasFolders = data.folders && data.folders.length > 0;

  return (
    <>
      {hasFolders ? (
        <div className="folder-grid">
          <SortButton />
          {data.folders.map((folder, index) => (
            <FolderCard key={folder._id} index={index} folder={folder} />
          ))}
        </div>
      ) : (
        <NoFolders />
      )}

      {showPagination && (
        <>
          <div className="section-divider" />
          <TablePagination
            totalRows={data.foldersCount}
            showRowsPerPageOptions={false}
            onChangePage={actions.handleChangePage}
          />
        </>
      )}

      <div className="section-divider" />

      <DocumentsListProvider
        section={documentTypes.MYFOLDERS}
        currentFolder={data.currentFolder}
      >
        <DocumentsList />
      </DocumentsListProvider>
    </>
  );
};

export default InsideFolderView;
